import { Download, Plus } from 'lucide-react'
import { useState } from 'react'
import { EmptyState } from '@/components/EmptyState'
import { Button } from '@/components/ui/button'
import { RecordListPage, type RecordListConfig } from '../list/RecordListPage'
import { AgreementBulkMenus } from './AgreementBulkMenus'
import { AgreementCardList } from './AgreementCardList'
import { agreementColumns } from './agreementColumns'
import { AgreementDialog } from './AgreementDialog'
import type { Agreement } from './types'

const noun = (count: number): string => (count === 1 ? '1 afspraak' : `${count} afspraken`)

const SORT_OPTIONS = [
  { value: 'next_due_on', label: 'Volgende deadline (eerst)' },
  { value: 'title', label: 'Afspraak (A–Z)' },
  { value: '-last_done_on', label: 'Laatst gedaan (nieuwste eerst)' },
  { value: 'ends_on', label: 'Einddatum (eerst)' },
] as const

/**
 * Afspraken (spec-63 E4, design §4.6): every agreement across all relations, on E2's list page with
 * views, filters, columns, bulk and export. A row leads to the relation's Afspraken tab.
 */
export function AgreementsPage() {
  const [dialogOpen, setDialogOpen] = useState(false)
  const newAgreement = (
    <Button type="button" aria-label="Nieuwe afspraak" onClick={() => setDialogOpen(true)}>
      <Plus />
      Afspraak
    </Button>
  )
  const config: RecordListConfig<Agreement> = {
    object: 'afspraken',
    title: 'Afspraken',
    subtitle: 'Wat VONK met relaties heeft afgesproken, en wat eraan komt',
    searchPlaceholder: 'Zoek op titel of relatie…',
    searchLabel: 'Zoek afspraken',
    noun,
    rowKey: (row) => row.id,
    rowLabel: (row) => row.title,
    columns: agreementColumns(),
    cardList: (rows) => <AgreementCardList rows={rows} />,
    sortOptions: SORT_OPTIONS,
    headerActions: (list, { exporting, exportRows }) => (
      <>
        <Button type="button" variant="outline" disabled={exporting || !list.query} onClick={() => void exportRows()}>
          <Download />
          {exporting ? 'Bezig…' : 'Exporteren'}
        </Button>
        {newAgreement}
      </>
    ),
    bulkMenus: (props) => <AgreementBulkMenus {...props} />,
    empty: <EmptyState title="Nog geen afspraken." description="Leg een afspraak vast bij een contact of organisatie, of hier." action={newAgreement} />,
    exportFilename: 'afspraken.xlsx',
    dialogs: (list) => <AgreementDialog open={dialogOpen} onOpenChange={setDialogOpen} party={null} onSaved={() => list.reload()} />,
  }
  return <RecordListPage config={config} />
}
